import { useAuthStore } from '@/store/modules/auth'
import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import ListView from '@/views/ListView.vue'
import PageNotFound from '@/views/PageNotFound.vue'
import Error from '@/views/Error.vue'
import TableRoutes from './tableRoutes'
import LogRoutes from './logRoutes'
import NoXmlTableRoutes from './noXmlTableRoutes'
import RelationRoutes from './relationRoutes'

function Base64DecodeUrl(rawUrl: string) {
  let str = rawUrl
  while (str.length % 4 !== 0) {
    str += '='
  }
  return str.replace(/-/g, '+').replace(/_/g, '/')
}

const routes = [
  {
    path: '/',
    name: '',
    redirect: { name: 'home' }
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/list',
    name: 'list',
    component: ListView
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/RegisterUser.vue')
  },
  {
    path: '/view/:path/:id',
    name: 'TableItemRow',
    component: () => import('@/views/TableRowItem.vue'),
    props: true
  },
  {
    path: '/road-to-competence-subgoal',
    name: 'RoadToCompetenceSubgoal',
    component: () => import('@/views/RoadToCompetenceSubgoal.vue'),
    meta: {
      breadcrumbs: [
        {
          text: 'route.list',
          to: 'list',
          link: true
        },
        {
          text: 'kodeverkTable.title.roadToCompetenceSubgoal',
          disabled: true
        }
      ]
    }
  },
  ...TableRoutes,
  ...NoXmlTableRoutes,
  ...LogRoutes,
  ...RelationRoutes,
  {
    path: '/error',
    name: 'Error',
    component: Error
  },
  {
    // will match everything
    path: '/:catchAll(.*)',
    component: PageNotFound
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, left: 0 }
  }
})

router.beforeEach((to: any, from: any, next: Function) => {
  const { authRequired } = to.meta
  const authStore = useAuthStore()

  if (authRequired && !authStore.isLoggedIn) {
    next('/home')
  } else {
    next()
  }
})

export default router
